import * as yup from 'yup';
export const validationSchema = yup.object({
  entityBody: yup.string().required('Il campo è obbligatorio'),
  domainType: yup.string().required().required('Il campo è obbligatorio'),
  domainName: yup
    .string()
    .required()
    .max(250, 'Il campo nome non può superare i 250 caratteri')
    .required('Il campo è obbligatorio'),
  usageNote: yup.string().nullable().notRequired(),
});

export enum ValueDomainModalOpenType {
  Add = 'add',
  Edit = 'edit',
  Read = 'read',
}
